import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { setActiveThread } from '../../../../redux/slices/conversationThreads';

const useOpenDashboardThreadEffect = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const threads = useAppSelector((state) => state.conversationThreads.threads);

  const populateActiveThreadFromParams = useCallback(
    (threadId: string) => {
      if (!threads.length) {
        return;
      }

      const foundThread = threads.find((thread) => thread.id === threadId);
      if (foundThread) {
        dispatch(setActiveThread(foundThread));
      }

      // Eventually reset search params
      setSearchParams('', { replace: true });
    },
    [dispatch, setSearchParams, threads],
  );

  // Open Conversation thread when there is a threadId in search params
  // (link is generated on Kobol side). Common use case is Slack channel
  useEffect(() => {
    if (searchParams && searchParams.has('threadId')) {
      const threadId = searchParams.get('threadId');
      if (threadId) {
        populateActiveThreadFromParams(threadId);
      }
    }
  }, [populateActiveThreadFromParams, searchParams]);
};

export default useOpenDashboardThreadEffect;
